var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSavedReports01 = function SvgSavedReports01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "saved_reports-01_svg2__a",
    x1: 23.09,
    x2: 200.11,
    y1: 192.69,
    y2: 15.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#saved_reports-01_svg2__a",
    id: "saved_reports-01_svg2__b",
    x1: -0.59,
    x2: 176.42,
    y1: 169.01,
    y2: -8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#saved_reports-01_svg2__a",
    id: "saved_reports-01_svg2__c",
    x1: 33.62,
    x2: 210.64,
    y1: 203.22,
    y2: 26.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#saved_reports-01_svg2__a",
    id: "saved_reports-01_svg2__d",
    x1: 49.41,
    x2: 226.43,
    y1: 219.01,
    y2: 42
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M31.58 0v94.74H0v68.42c0 18.56 13.73 33.9 31.58 36.46v.38H200V0zM10.53 163.16v-57.89h21.05v84.21c-12.45-2.54-21.31-13.61-21.05-26.32m178.94 26.31H42.11V10.53h147.37v178.95Z",
    style: {
      fill: "url(#saved_reports-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 105.26c20.35 0 36.84-16.49 36.84-36.84S120.35 31.58 100 31.58 63.16 48.07 63.16 68.42s16.49 36.84 36.84 36.84m5.26-11.05V73.68h20.53c-2.09 10.31-10.21 18.43-20.53 20.53M100 42.11c12.73 0 23.35 9.04 25.79 21.05H94.74v31.05c-12.01-2.44-21.05-13.06-21.05-25.79 0-14.53 11.78-26.32 26.32-26.32H100Z",
    style: {
      fill: "url(#saved_reports-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.16 115.79h105.26v10.53H63.16z",
    style: {
      fill: "url(#saved_reports-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.16 147.37h105.26v10.53H63.16z",
    style: {
      fill: "url(#saved_reports-01_svg2__d)"
    }
  }));
};
export default SvgSavedReports01;